import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, ConfigProvider } from 'antd';
import './styles.css';

const IMAGES = {
    hero: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/DSC_4702-1024x684-1.jpg',
    audit: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/image-8-1024x683.png',
    anketa: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/leon-dewiwje-ldDmTgf-1024x683.jpg',
    cows: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/pngwing.com-61-1024x610.png',
    sheep: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/pngwing-1-1024x804.png',
    calf: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/pngwing.com-63.png',
    tablet: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/pngwing.com-64-1024x970.png',
};

const benefitsList = [
    'Повышение рентабельности производства любых форм хозяйств',
    'Снижение расходов на лечение за счет правильного сбалансированного питания животных',
    'Повышение продуктивности животных',
    'Снижение затрат на кормление',
    'Снижение затрат на выращивание ремонтного молодняка, за счет сокращения срока выращивания.',
];

const forYouItems = [
    {
        text: 'Вы хотите оценить потенциал продуктивности стада',
        image: IMAGES.cows,
        alt: 'Коровы',
    },
    {
        text: 'Вы хотите сократить затраты на лечение продуктивных животных',
        image: IMAGES.sheep,
        alt: 'Овцы',
    },
    {
        text: 'Вы планируете закупку молодняка для ремонта стада',
        image: IMAGES.calf,
        alt: 'Телёнок',
    },
    {
        text: 'Вы хотите увеличить объемы производства и реализации продукции при ограниченных ресурсах',
        image: IMAGES.tablet,
        alt: 'Животноводство',
    },
];

const RationCalculation = () => {
    const navigate = useNavigate();

    return (
        <ConfigProvider
            theme={{
                token: { colorPrimary: '#D00202' },
                components: { Button: { colorPrimaryHover: '#ff3333' } },
            }}
        >
            <div className="ration-page">
                <div className="ration-container">
                    <h1 className="ration-title">Расчет и корректировка рациона</h1>

                    <section className="ration-hero">
                        <img src={IMAGES.hero} alt="Расчет рациона" className="ration-hero-img" />
                        <div className="ration-hero-text">
                            <p className="ration-hero-subtitle">
                                <em>Для тех, кто ценит свое время и заботится о здоровье животных.</em>
                            </p>
                            <ol className="ration-hero-list">
                                <li>Лучшие специалисты</li>
                                <li>Быстрая работа</li>
                                <li>Качественный результат</li>
                            </ol>
                        </div>
                    </section>

                    <section className="ration-section">
                        <h2 className="ration-section-title-center">Как производится расчет рациона?</h2>
                        <div className="ration-methods">
                            <div className="ration-method">
                                <img src={IMAGES.audit} alt="Аудит" className="ration-method-img" />
                                <h3>Аудит</h3>
                                <p>
                                    Специалисты Protect&Feed выезжают в ваше хозяйство и проводят аудит фермы с последующей разработкой рациона
                                </p>
                            </div>
                            <div className="ration-method">
                                <img src={IMAGES.anketa} alt="Анкета" className="ration-method-img" />
                                <h3>Анкета</h3>
                                <p>
                                    Вы заполняете анкету с указанием: действующего рациона на данный момент, его качества и запасах, с указанием численности поголовья и условиях его содержания.
                                </p>
                            </div>
                        </div>
                        <p className="ration-note">
                            На основании полученной информации наши специалисты разработают рацион для разных производственных групп животных. Важно! Мы всегда учитываем технологии содержания животных, принятые в каждом конкретном хозяйстве.
                        </p>
                    </section>

                    <section className="ration-section">
                        <h2 className="ration-section-title-center">Эта услуга для вас, если:</h2>
                        <div className="ration-for-you">
                            {forYouItems.map((item, i) => (
                                <div className={`ration-for-you-item ${i % 2 !== 0 ? 'ration-for-you-item--reverse' : ''}`} key={i}>
                                    <div className="ration-for-you-text">
                                        <p><strong>{item.text}</strong></p>
                                    </div>
                                    <div className="ration-for-you-image">
                                        <img src={item.image} alt={item.alt} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    <section className="ration-section">
                        <h2>Преимущества расчета и корректировки рациона:</h2>
                        <ol className="ration-benefits">
                            {benefitsList.map((item, i) => (
                                <li key={i}>{item}</li>
                            ))}
                        </ol>
                    </section>

                    <div className="ration-order-btn">
                        <Button
                            type="primary"
                            size="large"
                            onClick={() => navigate('/product/276326')}
                        >
                            Заказать услугу
                        </Button>
                    </div>
                </div>
            </div>
        </ConfigProvider>
    );
};

export default RationCalculation;
